module.exports = __webpack_public_path__ + "static/media/instagram_logo.b5de50bd.svg";